<template>
  <div>
    <TeacherAdminPageTableControl class="mb-5"></TeacherAdminPageTableControl>
    <AppPageCard>
      <template #card-title>
        {{ $t("EDUGENERAL.MESSAGE.TEACHERROLE") }}
      </template>
      <template #card-toolbar>
        <div
          class="btn btn-icon btn-light btn-hover-primary mr-3"
          v-on:click="refresh"
          v-b-tooltip.hover
          :title="$t('COMMON.TOOLTIP.REFRESH')"
        >
          <span class="svg-icon svg-icon-lg svg-icon-primary">
            <inline-svg src="/media/svg/icons/Media/Repeat.svg" />
          </span>
        </div>
      </template>
      <TeacherAdminPageTable :reload="reload"></TeacherAdminPageTable>
    </AppPageCard>
  </div>
</template>

<script>
import AppPageCard from "@/modules/core/components/shared/card/AppPageCard";
import TeacherAdminPageTable from "@/modules/school/components/teacher/admin/TeacherAdminPageTable";
import TeacherAdminPageTableControl from "@/modules/school/components/teacher/admin/TeacherAdminPageTableControl";
export default {
  name: "TeacherAdminPage",
  components: {
    TeacherAdminPageTableControl,
    TeacherAdminPageTable,
    AppPageCard,
  },
  data() {
    return {
      reload: false,
    };
  },
  methods: {
    refresh() {
      this.reload = !this.reload;
    },
  },
};
</script>

<style scoped></style>
